import type {RateConferenceConfig} from './types';

import {conferenceAddFeedback} from '../../services/entity-action/conference/conference.add-feedback';
import {isCancelCommand} from '../../services/entity-action/utils';
import {logger} from '../../utils/logger';
import {storage} from '../../utils/storage';
import {showSessionResultAlert} from './SessionResultAlert';
import {DONT_SHOW_CONFERENCE_FEEDBACK_STORAGE_KEY} from './utils';

// it's a future use case
export const runRateConferenceFlow = async (
  config: RateConferenceConfig,
  options?: {
    runCommonFlow?: (config: RateConferenceConfig) => void;
  },
) => {
  const dontShowRating = await storage.getItem(
    DONT_SHOW_CONFERENCE_FEEDBACK_STORAGE_KEY,
  );

  if (dontShowRating === 'true') {
    return;
  }

  if (config.role === 'coach' && config.type === 'chat') {
    logger.event('session_rate_view', {
      role: config.role,
      session_type: config.type,
    });

    const result = await showSessionResultAlert();

    if (!isCancelCommand(result)) {
      try {
        await conferenceAddFeedback({
          id: config.id,
          ratings: {
            client_not_show: result === 'client_not_show' ? 1 : undefined,
            completed_successfully:
              result === 'completed_successfully' ? 1 : undefined,
          },
          role: config.role,
          type: config.type,
        });
      } catch (error) {
        logger.error(error);
      }
    }
  } else {
    options?.runCommonFlow?.(config);
  }
};
